import type { TimePeriod } from './types';

export const PERIOD_OPTIONS: { value: TimePeriod; label: string; hours: number }[] = [
    { value: '24h', label: '24 часа', hours: 24 },
    { value: '7d', label: '7 дней', hours: 168 },
    { value: '30d', label: '30 дней', hours: 720 },
    { value: '90d', label: '90 дней', hours: 2160 },
    { value: 'custom', label: 'Период...', hours: 0 },
];

export const CHART_COLORS = {
    primary: '#2563EB',
    primaryLight: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    purple: '#8B5CF6',
    cyan: '#06B6D4',
    grid: 'rgba(0,0,0,0.05)',
    gridDark: 'rgba(255,255,255,0.05)',
} as const;

export const HEATMAP_COLORS = {
    excellent: { bg: 'rgba(16,185,129,0.9)', text: '#fff' },
    good: { bg: 'rgba(59,130,246,0.8)', text: '#fff' },
    warning: { bg: 'rgba(245,158,11,0.8)', text: '#fff' },
    critical: { bg: 'rgba(239,68,68,0.9)', text: '#fff' },
    empty: { bg: 'rgba(0,0,0,0.03)', text: 'var(--text-muted)' },
};

export const SLA_TARGETS = {
    standard: 99.0,
    premium: 99.9,
    enterprise: 99.99,
};

export const ANIMATION_CONFIG = {
    stagger: 0.05,
    duration: 0.4,
    spring: { stiffness: 100, damping: 15 },
    ease: [0.25, 0.1, 0.25, 1],
};

export const REFRESH_INTERVAL = 30000;

export const DEBOUNCE_DELAY = 300;